import {createContext, Dispatch} from 'react'
import {CustomLanding36252Action, CustomLanding36252ActionType, CustomLanding36252State} from './types'

export const reducer = (
  state: CustomLanding36252State,
  action: CustomLanding36252Action,
): CustomLanding36252State => {
  if (action.type === CustomLanding36252ActionType.ChangeLanguageAction) {
    return {
      ...state,
      language: action.payload,
      languageSelectorOpen: false
    }
  }

  if (action.type === CustomLanding36252ActionType.OpenLanguageSelector) {
    return {
      ...state,
      languageSelectorOpen: true
    }
  }

  if (action.type === CustomLanding36252ActionType.Dismiss) {
    return {
      ...state,
      dismissed: true,
    }
  }

  return state
}

export const initialState: CustomLanding36252State = {
  dismissed: false,
  language: navigator.languages.some(lang => lang.includes('ar')) ? 'ar' : 'en',
  languageSelectorOpen: false
}

export const CustomLanding36252Context = createContext<
  [CustomLanding36252State, Dispatch<CustomLanding36252Action> | null]
>([initialState, null])
